// eslint-disable-next-line no-unused-vars
import Development from "./DEV.json";

const fe_config = Development;
export default fe_config;
